export const AUTH_TOKEN_COOKIE_KEY = "access_token";

const AUTH_SESSION_API_ENDPOINT = "/api/auth/session";

type AuthSessionApiResponse = {
  authenticated?: boolean;
  token?: string | null;
};

async function readSessionApiResponse(response: Response) {
  try {
    const payload = (await response.json()) as AuthSessionApiResponse;
    return payload;
  } catch {
    return null;
  }
}

export async function readAuthTokenCookie() {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const response = await fetch(`${AUTH_SESSION_API_ENDPOINT}?includeToken=1`, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      credentials: "include",
      cache: "no-store",
    });

    if (!response.ok) {
      return null;
    }

    const payload = await readSessionApiResponse(response);
    return payload?.authenticated === true && typeof payload.token === "string"
      ? payload.token
      : null;
  } catch {
    return null;
  }
}

export async function clearAuthTokenCookie() {
  if (typeof window === "undefined") {
    return;
  }

  try {
    await fetch(AUTH_SESSION_API_ENDPOINT, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
      },
      credentials: "include",
    });
  } catch {
    // Ignore clear failures so logout UX can proceed.
  }
}
